import pulse from '@finn-no/pulse-sdk';

export function trackModal(id, type, intent, objectName) {
    pulse.trackEvent({
        type,
        intent,
        name: 'Job profile',
        object: {
            id,
            type: 'UIElement',
            elementType: 'Popup',
            position: 'MarketFrontpage',
            name: objectName,
        },
        vertical: {
            name: 'job',
        },
    });
}

export function trackModalEntryBtnClick() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Job profile',
        object: {
            id: 'job_profile_landing_create_profile_link_click',
            type: 'UIElement',
            elementType: 'Popup',
            position: 'MarketFrontpage',
        },
        target: {
            id: '/job/profile/onboarding/work-situation',
            type: 'UserProfilePage',
            pageType: 'my_account',
        },
        vertical: {
            name: 'job',
        },
    });
}

/**
 * @param {string} targetId - URL of the anchor's target
 * @param {('Listing'|'MarketFrontpage')} objectPosition - Where the podlet is mounted (search result or market frontpage)
 * @param {string} name - Name of the event, defaults to 'Job profile'
 * @param {string?} objectName - Optional object name to differentiate between events
 */
export function trackEntryBtnClick(
    targetId,
    objectPosition,
    objectName,
    name = 'Job profile',
) {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name,
        object: {
            id: 'job_profile_entry_click',
            type: 'UIElement',
            elementType: 'Banner',
            position: objectPosition,
            name: objectName,
        },
        target: {
            id: targetId,
            type: 'UserProfilePage',
            pageType: 'my_account',
        },
        vertical: {
            name: 'job',
        },
    });
}

/**
 *
 * @param {boolean} hasActiveJobProfile
 */
export function trackSalaryEntryInscreen(hasActiveJobProfile) {
    // JOB_ev81
    pulse.trackEvent({
        type: 'View',
        intent: 'View',
        name: 'Salary comparison',
        object: {
            id: 'salary_comparison_view',
            type: 'UIElement',
            elementType: 'Banner',
            name: hasActiveJobProfile ? 'active profile' : 'no profile',
            position: 'MarketFrontpage',
        },
        vertical: {
            name: 'job',
        },
    });
}

/**
 *
 * @param {boolean} hasActiveJobProfile
 */
export function trackSalaryEntryBtnClick(hasActiveJobProfile) {
    // JOB_ev80
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Salary comparison',
        object: {
            id: 'salary_comparison_click',
            type: 'UIElement',
            elementType: 'Button',
            position: 'MarketFrontpage',
            name: hasActiveJobProfile ? 'active profile' : 'no profile',
        },
        vertical: {
            name: 'job',
        },
    });
}
